import styled from 'styled-components'

export const HelpWrapper = styled.div`
  width: 100%;
  margin-left: 0px !important;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  position: relative;
`

export const HelpHeader = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.secondPrimary};
  height: 269px;
  color: ${({ theme }) => theme.colors.white};
  position: absolute;
  top: 0px;
  .text_wrapper {
    padding: 10px 32px;
  }
  .text_wrapper p {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 140%;
    margin-top: -10px;
    color: #f2f2f2;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: 16px;
      margin-top: -15px;
    }
  }

  .text_img_wrapper {
    display: flex;

    h1 {
      font-weight: 600;
      font-size: 48px;
      line-height: 58px;
      padding-right: 17px;
    }
  }
`

export const HelpBody = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 12px 24px rgba(40, 41, 61, 0.06);
  border-radius: 10px;
  width: 370px;
  height: auto;
  padding: 10px 24px;
  position: absolute;
  top: 13rem;

  .title {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.05px;
    color: ${({ theme }) => theme.colors.black};
  }

  .help_flex {
    display: flex;
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #eff0f2;
    box-sizing: border-box;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    align-items: center;
    /* justify-content: center; */
    margin-bottom: 20px;
    height: 50px;
  }

  .help_accordion {
    width: 100%;
  }
`
